// gsap.registerPlugin(ScrollTrigger);


class ProductEnhanced {
      constructor(root, config) {
        const { variantPicker, productContainer, gallery, productInfo, product_metafields, moreOptions } = root;
        this.root = variantPicker;
        this.container = productContainer;
        this.config = config;
        this.gallery = gallery;
        this.productInfo = root.productInfo;
        this.metafields = product_metafields;
        this.options = moreOptions;
        this.variants = config.product.variants || [];
        this.optionsCount = config.optionsCount || 0;
        this.selectEl = this.root.querySelector('.ltp-variant-select');
        this.current = (config.current || []).slice(); // array de opciones actuales
        this.counter = 1;
        this.metafieldsData = {
          features: null,
          specifications: null,
          recommendations: null,
          key_features: null,
          featuredFlickity: null,
          recommendationsFlickity: null,
          key_featuresFlickity: null
        };
        this.customization = this.container.querySelector('[data-custom-form]');
        this.custom_form = {
          button: this.container.querySelector('[data-custom-trigger]'),
          container: this.container.querySelector('[data-custom-form]')
        };

        this._onResize = this._debounce(this._handleResize.bind(this), 150);


        // Mapa variante -> { id, available }
        this.map = new Map();
        this.variants.forEach(v => {
          this.map.set(this.keyFromOptions(v.options), {
            id: v.id,
            available: v.available
          });
        });

        // Qué chip está visualmente activo por índice de opción (solo para Compatibility chips)
        this.activeChipByIndex = {};

        // Bind
        this.onClick = this.onClick.bind(this);

       // Init

       if (root.gallery && config) {
         this.enhancerComponent = new ProductEnhancer(root.gallery, config, this);
       }

        this.init()


        window.addEventListener('resize', this._onResize, { passive: true });
        this._handleResize();

        // Listeners
        this.root.addEventListener('click', this.onClick);

        this._expandrootslisteners()

      }

        init() {
          this.initActiveChips();
          this.markSelected();
          this.refreshDisabled();
          this.syncVariant();
          this.markTitle()
          this.setupATC_actions();
          this.setupOnClickZoom();
          this.setupMetafieldsContainer();
          this.addonsSetup();
          if (window.innerWidth <= 768) {
            this.setupMobileGallery();
          }

          const product = this.config.product;

          if (product.tags.includes('MOQ')) this._setupForm()

          if (this.custom_form.button && this.custom_form.container) {
            this.custom_form.button.addEventListener('click', (e) => {
              e.preventDefault();
              this.custom_form.container.classList.add('is-active');
              this._openCustomForm();
            });
          }

        }

        _openCustomForm() {
          const closeBtn = this.custom_form.container.querySelector(".form-close")
          const inputFile = this.custom_form.container.querySelector("input[type='file']")

          this.custom_form.container.addEventListener('click', (e) => {
            if (e.target.classList.contains('is-active')) {
              this.custom_form.container.classList.remove('is-active');
            }
          });

          closeBtn.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            this.custom_form.container.classList.remove('is-active');
          })
        }

        _setupForm() {

          const url = new URL(window.location.href);

          const contact_posted = url.searchParams.get('contact_posted');

          if (contact_posted === 'true') {
            this._setupModalRequestCallback();
          }

          const html = document.documentElement;
          const header = document.querySelector('[data-site-header]');
          const requestInfo = document.querySelector('[data-modal-request]');
          const modalRequest = document.querySelector('[data-modal-content]');
          const modal = modalRequest?.querySelector('.modal_request');
          const openBtn = requestInfo?.querySelector('button.request-btn');
          const closeBtn = modalRequest?.querySelector('[data-close-modal]');

          const toggleModal = (show) => {
            const method = show ? 'add' : 'remove';
            modalRequest.dataset.modalContent = show ? 'true' : 'false';
            requestInfo.classList[method]('open');
            header.style.zIndex = show ? '1' : '';
            html.classList[method]('scroll-locked');

            if (show) {
              document.addEventListener('wheel', handleManualScroll, { passive: false });
            } else {
              document.removeEventListener('wheel', handleManualScroll);
            }
          };

          // 🎯 Manual scroll handler
          const handleManualScroll = (e) => {
            if (modal) {
            modal.style.scrollBehavior = 'smooth';
          

            document.addEventListener('wheel', (event) => {
              if(event.deltaY > 0) {
                //scrolled Down
                modal.scrollTop += 200; 
              } else {
              // Scrolled up
              modal.scrollTop -= 200;
              }
            });
          }
          };

          // Abrir
          if (openBtn) {
            openBtn.addEventListener('click', (e) => {
              e.preventDefault();
              toggleModal(true);
            });
          }

          // Cerrar botón
          if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
              e.preventDefault();
              toggleModal(false);
            });
          }

          // Cerrar por backdrop
          modalRequest?.addEventListener('click', (e) => {
            if (e.target === modalRequest) {
              toggleModal(false);
            }
          });
        }


       // --- to clean up when destroying this component ---
        destroy() {
            window.removeEventListener('resize', this._onResize);
            if (this.flickity) {
              this.flickity.destroy();
              this.flickity = null;
            }
            if (this.flickityThumb) {
              this.flickityThumb.destroy();
              this.flickityThumb = null;
            }
            if (this._unbindThumbListeners) this._unbindThumbListeners();
            this._thumbCellRemovers = [];
            this._flListenersBound = false;
        }

        // --- Debounce helper to avoid excessive re-initialization on resize ---
        _debounce(fn, wait = 150) {
          let t;
          return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn(...args), wait);
          };
        }

        _setupOpenContainerEvent(container, type) {

          const plusbtn = container.querySelector('legend')
          const btn = plusbtn.children[1];

          plusbtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            container.classList.toggle(type);
          });
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            container.classList.toggle(type);
          });
        }

        _expandrootslisteners() {
          const roots = Array.from(this.root.querySelectorAll(".ltp-field"))

          if (roots.length > 0) {
            roots.forEach(container => {
              const sub_container = container.querySelector(".ltp-chips-grid")
              const btn = container.querySelector("[data-trigger-opener]")

              this._setupContainer(sub_container, btn)
            })
          }

        }

        _setupContainer(sub_container, btn) {
          if (!sub_container || !btn) return;

          btn.addEventListener('click', (e) => {
            if (sub_container.dataset.open === "true") {
              sub_container.dataset.open = "false"
              btn.dataset.open = "false"
              
            } else {
              sub_container.dataset.open = "true"
               btn.dataset.open = "true"
            }
          })
        }

        addonsSetup() {
          const addonscontainer = Array.from(this.productInfo.querySelectorAll('[data-addons]'));
          if (addonscontainer.length === 0) return;

          addonscontainer.forEach(container => {
            this._setupOpenContainerEvent(container, "openCon");
          });

          const addonItems = addonscontainer.flatMap(container => Array.from(container.querySelectorAll('[data-addon-item]')));
          addonItems.forEach(item => {
            // Initialize each addon item
            this.initAddonItem(item);
          });
        }

        initAddonItem(item) {
          const atc = item.querySelector('.btn-addon');

          if (!atc) return;

          const productId = item.dataset.productId;

          const counter = item.querySelector('[data-counter-events]');

          this.counterActions(counter, true)

          atc.addEventListener('click', (e) => {
            const formData = [
            {
              name: 'id',
              value: productId
            }, {
              name: 'quantity',
              value: counter ? counter.value : 1
            }
          ]

          const options = {
            atcButton: atc,
            settings: {
              moneyFormat: this.config.settings.money_format,
              cartRedirection: this.config.settings.cart_redirection,
              cart_drawer_state: this.config.settings.message_after_atc,
              isQuickShop: false
            }
          }

          new window.AddToCartFlyout(formData, options, this.config.settings.context)
          });

        }

        // --- Resize handler decides between mobile (<=768) and desktop (>768) modes ---
        _handleResize() {
          const isMobile = window.innerWidth <= 768;

          const width = window.innerWidth;

          this._keyfeatures(width)
          this._metafeatures(width)
          this._metaRecommendations(width)


          if (isMobile) {
            // Ensure mobile gallery with synced thumbnails
            this.setupMobileGallery(true);
          } else {
            // Desktop: destroy any Flickity instances to keep static layout
            if (this.flickity) {
              this.flickity.destroy();
              this.flickity = null;
            }
            if (this.flickityThumb) {
              this.flickityThumb.destroy();
              this.flickityThumb = null;
            }
            // Also remove click listeners when leaving mobile mode
            if (this._unbindThumbListeners) this._unbindThumbListeners();
            this._unbindThumbListeners = null;
            this._thumbCellRemovers = [];
            this._flListenersBound = false;
          }
        }

        // --- Factory for Flickity instances (keeps window.js_default() as requested) ---
        setupFlickity({ container, cellSelector, arrowShape, buttons, freeScroll, ...settings }) {
          if (!container) return null;
          return new (window.js_default())(container, {
            accessibility: false,
            adaptiveHeight: false,
            cellSelector: cellSelector ?? null,
            contain: true,
            margin: 20,
            cellAlign: 'center',
            friction: 0.5,
            freeScroll: !!freeScroll,
            initialIndex: 0,
            lazyLoad: false,
            percentPosition: false,
            prevNextButtons: !!buttons,
            arrowShape: arrowShape || null,
            pageDots: false,
            ...settings
          });
        }

        // --- Initializes mobile gallery: main carousel + thumbnails (nav or plain) ---
        setupMobileGallery(resize = false) {
          if (!this.gallery) return;

          const gallery = this.gallery.querySelector('.product-viewer-slides');
          const thumbnails = this.gallery.querySelector('[data-gallery-thumbnails]');
          if (!gallery || !thumbnails) return;

          const thumbItems = Array.from(
            thumbnails.querySelectorAll('[data-gallery-thumbnail]')
          );

          // 1) Main carousel
          if (!this.flickity) {
            this.flickity = this.setupFlickity({
              container: gallery,
              cellSelector: '[data-gallery-figure]',
              buttons: false
            });
          }

          // 2) Thumbnails: if they overflow, use Flickity as navigation; else plain clicks
          const needThumbCarousel = this.thumbnailsViewport(thumbItems);

          // If a thumb carousel exists but is not needed anymore, destroy and cleanup
          if (this.flickityThumb && !needThumbCarousel) {
            this.flickityThumb.destroy();
            this.flickityThumb = null;
            if (this._unbindThumbListeners) this._unbindThumbListeners();
            this._thumbCellRemovers = [];
            this._flListenersBound = false;
          }

          if (needThumbCarousel) {
            if (!this.flickityThumb) {
              // Use selector for asNavFor to make it more stable than passing a node
              this.flickityThumb = this.setupFlickity({
                container: thumbnails,
                cellSelector: '[data-gallery-thumbnail]',
                asNavFor: '.product-viewer-slides',
                freeScroll: true,
                buttons: false,
                draggable: '>1'
              });
              this.flickityListeners(this.flickity, this.flickityThumb);
            }
          } else {
            // Simple thumbnail clicks (no Flickity on thumbnails)
            this.setupThumb();
          }
        }

        // --- Returns true if thumbnails total width exceeds their container width ---
        thumbnailsViewport(thumbnailsFigure) {
          if (!thumbnailsFigure || thumbnailsFigure.length === 0) return false;

          const container = thumbnailsFigure[0].parentElement;
          if (!container) return false;

          const containerMaxWidth = container.clientWidth;
          let total = 0;

          thumbnailsFigure.forEach((thumbnail) => {
            const rect = thumbnail.getBoundingClientRect();
            const width = rect.width || thumbnail.offsetWidth;
            const styles = getComputedStyle(thumbnail);
            const marginLeft = parseFloat(styles.marginLeft || '0');
            const marginRight = parseFloat(styles.marginRight || '0');
            total += width + marginLeft + marginRight;
          });

          return total > containerMaxWidth;
        }

        // --- Thumbnails behavior without Flickity on the thumbnails row ---
        setupThumb() {
          if (!this.flickity) return;

          const thumbnails = this.gallery.querySelector('[data-gallery-thumbnails]');
          const thumbs = Array.from(thumbnails.querySelectorAll('[data-gallery-thumbnail]'));
          if (thumbs.length === 0) return;

          // Cleanup previous bindings to avoid duplicated listeners
          if (this._unbindThumbListeners) this._unbindThumbListeners();

          const onChange = (index) => {
            this.checkSelectedThumbnail(thumbs);
            if (thumbs[index]) thumbs[index].classList.add('is-selected');
          };

          // Ensure previous handler is removed, then bind a fresh one
          if (this._onMainChange) this.flickity.off?.('change', this._onMainChange);
          this._onMainChange = onChange;
          this.flickity.on('change', onChange);

          const removers = [];
          thumbs.forEach((thumb, index) => {
            thumb.dataset.thumbIndex = index;
            thumb.dataset.galleryIndex = index;
            if (index === 0) thumb.classList.add('is-selected');

            const handler = () => {
              this.flickity.select(index);
              this.checkSelectedThumbnail(thumbs);
              thumb.classList.add('is-selected');
            };
            thumb.addEventListener('click', handler);
            removers.push(() => thumb.removeEventListener('click', handler));
          });

          // Store a function that unbinds all thumb listeners and main change handler
          this._unbindThumbListeners = () => {
            removers.forEach((fn) => fn());
            this.flickity.off?.('change', onChange);
          };
        }

        // --- Utility to clear the selection class before setting a new one ---
        checkSelectedThumbnail(thumbnails) {
          thumbnails.forEach((t) => t.classList.remove('is-selected'));
        }

        // --- Keeps main carousel and thumbnails carousel in sync ---
        flickityListeners(flkty, flktyThumb) {
        if (!flkty || !flktyThumb) return;
        if (this._flListenersBound) return; // avoid multiple binding
        this._flListenersBound = true;

        const onMainChange = (index) => flktyThumb.select(index);
        flkty.on('change', onMainChange);

        // Click on each thumbnail cell selects the corresponding main slide
        flktyThumb.cells.forEach((cell, index) => {
          const el = cell.element;
          const handler = () => flkty.select(index);
          el.addEventListener('click', handler);
          // this._thumbCellRemovers.push(() => el.removeEventListener('click', handler));
        });

        // Patch destroy() to also unbind our listeners and flags
        const originalDestroy = flktyThumb.destroy.bind(flktyThumb);
        flktyThumb.destroy = () => {
          flkty.off('change', onMainChange);
          this._thumbCellRemovers.forEach((fn) => fn());
          this._thumbCellRemovers = [];
          this._flListenersBound = false;
          originalDestroy();
        };
      }

      _atcButton(button, dynamic_atc = false) {
        if (!button) return;
      
        button.addEventListener('click', () => {
          const formData = [
            {
              name: 'id',
              value: dynamic_atc ? button.dataset.productId : this.currentVariantState.id
            }, {
              name: 'quantity',
              value: dynamic_atc ? 1 : this.counter
            }
          ]

          const options = {
            atcButton: button,
            settings: {
              moneyFormat: this.config.settings.money_format,
              cartRedirection: this.config.settings.cart_redirection,
              cart_drawer_state: "",
              isQuickShop: false
            }
          }

          new window.AddToCartFlyout(formData, options, this.config.settings.context)
        });
      }

      setupATC_actions(selector = "[data-cart-actions]", dynamic_container = false, container = null) {

        let atcContainer = null;
        
        if (dynamic_container) {
          atcContainer = container.querySelector(selector);
          this._atcButton(atcContainer, true);
          return;
        } else {
          atcContainer = this.productInfo.querySelector(selector);
        }
        
        if (!atcContainer) return;
        

        const atcButton = atcContainer.querySelector('.add-to-cart_button');
        if (atcButton) {
          this._atcButton(atcButton);
        }

        const counter = atcContainer.querySelector('.quantity_selector');
        if (counter) {
          this.counterActions(counter);
        }

      }

      setupOnClickZoom() {
        const images = Array.from(this.gallery.querySelectorAll('[data-figure_img]'))
        const actualMetafield = this.config.variant_metafields.filter(m => m.id === this.currentVariantState?.id);
        const metafieldImages = actualMetafield[0].metafields.images_featured

        images.forEach((figures, index) => {
          if (!figures) return;

          figures.setAttribute('data-listener-active', true);

          figures.addEventListener('click', () => {
            this.setupZoom(
              this.config.settings,
              images,
              figures,
              Array.from(this.gallery.querySelectorAll('[data-gallery-thumbnail]')),
              index
            );
          });

        })
      }

      setupZoom(settings, slides, startSlide, originalThumbnails, startIndex) {
        if (!settings || !slides || !originalThumbnails) return;
        this.galleryZoom = new ProductClickToZoom({
          settings,
          slides,
          startSlide,
          originalThumbnails,
          startIndex
        });
      }

      

      counterActions(counterContainer, dynamic_counter = false) {
        if (!counterContainer) return;
        
        const incrementButton = counterContainer.querySelector(dynamic_counter ? '.quantity-plus' : '.quantity_increase');
        const decrementButton = counterContainer.querySelector(dynamic_counter ? '.quantity-minus' : '.quantity_decrease');
        const quantityInput = counterContainer.querySelector(dynamic_counter ? '.quantity' : '.quantity_input');

        incrementButton.addEventListener('click', () => {

          if (dynamic_counter) {
            const numb = Number(quantityInput.value)
            quantityInput.value = numb + 1;
          } else {
            this.counter ++;
            quantityInput.value = this.counter;

          }

        });

        decrementButton.addEventListener('click', () => {
          if (dynamic_counter) {
            const num = Math.max(1, (parseInt(quantityInput.value,10) || 1) - 1);
            quantityInput.value = num;
          } else {
            if (this.counter > 1) this.counter--;
            quantityInput.value = this.counter;
          }
        });

        quantityInput.addEventListener('input', (e) => {
          const value = e.target.value;
          const parsedValue = parseInt(value, 10);
          if (dynamic_counter) {
            quantityInput.value = isNaN(parsedValue) ? 1 : parsedValue;
          } else {
            this.counter = isNaN(parsedValue)
              ? 1
              : parsedValue;
          }
        });

      }

      markTitle() {
        const titleEl = this.productInfo.querySelector('.product_title');
      }


     // ========== Utils ==========
      keyFromOptions(opts) {
        return(opts || []).map(v => String(v).trim().toLowerCase()).join(' / ');
      }

      // ========== Chips (Compatibility) ==========
      initActiveChips() {
        this.root.querySelectorAll('.ltp-chips-grid').forEach(grid => {
          const idx = Number(grid.dataset.chipsIndex);
          const currentVal = this.current[idx];
          const firstChip = Array.from(grid.querySelectorAll('.ltp-chip')).find(c => c.dataset.optValue === String(currentVal));
          if (firstChip) 
            this.activeChipByIndex[idx] = firstChip.dataset.chip;
          
        });
      }

      markActiveChips() {
        this.root.querySelectorAll('.ltp-chip').forEach(chip => {
          const idx = Number(chip.dataset.optIndex);
          const inSelectedGroup = String(chip.dataset.optValue) === String(this.current[idx]);
          const isActive = this.activeChipByIndex[idx] && chip.dataset.chip === this.activeChipByIndex[idx];
          chip.classList.toggle('is-selected', inSelectedGroup && isActive);
          chip.setAttribute(
            'aria-pressed',
            (inSelectedGroup && isActive)
              ? 'true'
              : 'false'
          );

          if (isActive && inSelectedGroup) {

            const match = this.map.get(this.keyFromOptions(this.current));
            const currentVariant = this.variants.find(v => v.id === match.id);
            
            this.currentChip = chip;
            this.enhancerComponent?.switchVariantChip(chip, currentVariant);
          }

        });
      }

      // ========== Estado/Disponibilidad ==========
      refreshDisabled() {
        const allButtons = this.root.querySelectorAll('[data-opt-index]');
        allButtons.forEach(btn => {
          const idx = Number(btn.dataset.optIndex);
          const val = btn.dataset.optValue; // para chips es el grupo completo
          const trial = this.current.slice();
          trial[idx] = val;

          const exists = this.variants.some(v => {
            for (let i = 0; i < this.optionsCount; i++) {
              const cand = (
                i === idx
                  ? val
                  : (trial[i] ?? this.current[i])
              );
              if (String(v.options[i]).toLowerCase() !== String(cand).toLowerCase()) return false;
              
            }
            return true;
          });

          btn.disabled = ! exists;

        });
      }

      markSelected() {
        const buttons = this.root.querySelectorAll('[data-opt-index]');
        buttons.forEach(btn => {
          const idx = Number(btn.dataset.optIndex);
          const val = btn.dataset.optValue;
          const isSel = String(this.current[idx]).toLowerCase() === String(val).toLowerCase();

       // Para chips, la selección visual fina la hace markActiveChips()
          if (!btn.classList.contains('ltp-chip')) {
            btn.classList.toggle('is-selected', isSel);
            btn.setAttribute(
              'aria-pressed',
              isSel
                ? 'true'
                : 'false'
            );

          }

        });
        this.markActiveChips();
      }

      syncVariant(initialMount = false) {
        const match = this.map.get(this.keyFromOptions(this.current));
        if (! match) return;
        


        if (match.id === this.currentVariantState?.id) return;
        

        if (this.selectEl) {
          this.selectEl.value = String(match.id);
          this.selectEl.dispatchEvent(new Event('change', {bubbles: true}));
        }

        // Hook opcional para otros scripts (precio/galería)
        this.root.dispatchEvent(new CustomEvent('pe:variant-change', {
          bubbles: true,
          detail: {
            variantId: match.id,
            options: this.current,
            available: match.available
          }
        }));
        this.currentVariantState = match

        this.syncURL(match);
        this.syncMetafields(match, initialMount);

      }

      syncMetafields(match, initialMount) {
        const actualMetafield = this.config.variant_metafields.filter(m => m.id === match.id);

        const data = {
          actualMetafield: actualMetafield,
          currentVariant: this.variants.find(v => v.id === match.id),
          product: this.config.product,
          currentChip: this.currentChip,
          chipChanged: initialMount
        }

        if (initialMount) {
          this.enhancerComponent?.switchVariantData(data);
        }

      }

      syncURL(match) {
        if (match) {
          const url = `${
            this.config.product.handle
          }?${
            window.jQuery.param({variant: match.id})
          }`;
          history.replaceState({}, 'variant', url);
        }
      }

      // ========== Eventos ==========
      onClick(e) {
        const t = e.target.closest('[data-opt-index]');
        if (! t || t.disabled) return;
        

        const idx = Number(t.dataset.optIndex);
        const val = t.dataset.optValue;

      // Si es chip, recordamos qué chip textual quedó activo
        if (t.classList.contains('ltp-chip')) {
          this.activeChipByIndex[idx] = t.dataset.chip;
        }

        this.current[idx] = val;
        this.markSelected();
        this.refreshDisabled();
        this.syncVariant(true);

      }

      setupMetafieldsContainer() {
        if (!this.metafields) return;

        const features = this.metafields.querySelector('[data-features-container]')

        if (features) {
          this.metafieldsData.features = features;
        }

        const specifications = this.metafields.querySelector('[data-specifications]')
        if (specifications) {
          this.metafieldsData.specifications = specifications;
        }

        const recommendations = this.metafields.querySelector('[data-product-recommendations]')
        if (recommendations) {
          this.metafieldsData.recommendations = recommendations;
        }

        const key_features = this.metafields.querySelector('[data-key-features]')
        if (key_features) {
          this.metafieldsData.key_features = key_features;
        }

      }

      _metaRecommendations(width) {
        if (!this.metafieldsData || !this.metafieldsData.recommendations) return;
        
        let maxWidth = 0
        const recommendationsContainer = this.metafieldsData.recommendations;
        const items = Array.from(recommendationsContainer.querySelectorAll('[data-card-recomm]'));
        items.forEach(item => {
          const itemWidth = item.offsetWidth;
          maxWidth += itemWidth;
          this.setupATC_actions(".card_product--btn", true, item);
        });

        if (width < maxWidth) {

          if (this.metafieldsData.recommendationsFlickity) {
            this.metafieldsData.recommendationsFlickity.destroy();
            this.metafieldsData.recommendationsFlickity = null;
          }

          this.metafieldsData.recommendationsFlickity = this.setupFlickity({
              container: this.metafieldsData.recommendations.children[0],
              cellSelector: '[data-card-recomm]',
              buttons: false,
              resize: true
            });

        }
      }

      _keyfeatures(width) {
        if (!this.metafieldsData || !this.metafieldsData.key_features) return;

        let maxWidth = 0
        const keys_container = this.metafieldsData.key_features.querySelector('.features--list');

        const key_items = Array.from(keys_container.querySelectorAll('.product-key_features--image'));

        key_items.forEach(item => {
          const itemWidth = item.offsetWidth;
          maxWidth += itemWidth;
        });

        const containerW = keys_container.offsetWidth;

        if (maxWidth >= containerW) {
          if (this.metafieldsData.key_featuresFlickity) {
            this.metafieldsData.key_featuresFlickity.destroy();
            this.metafieldsData.key_featuresFlickity = null;
          }

          this.metafieldsData.key_featuresFlickity = this.setupFlickity({
              container: keys_container,
              cellSelector: '.product-key_features--image',
              buttons: false,
              resize: true,
              initialIndex: 2,
              autoPlay: 2000,
              pauseAutoPlayOnHover: true
            });
        }

      }

      getMiddleIndex(n, preferRight = false) {
        if (n <= 0) return 0;
        return preferRight ? Math.ceil((n - 1) / 2) : Math.floor((n - 1) / 2);
      }

      updateCompactFlag(flkty, container) {
        if (!flkty || !container) return;
        const vpW = flkty.viewport.clientWidth;
        const selCell = flkty.cells[flkty.selectedIndex];
        const cellW = selCell ? selCell.size.outerWidth : vpW;
        const fullVisible = Math.floor(vpW / cellW);
        const isCompact = fullVisible < 3;
        container.classList.toggle('is-compact', isCompact);
      }

      /* -------- helpers -------- */
      _previusSlide(selectedIndex, length) {
        const n = length ?? this.metafieldsData?.featuredFlickity?.cells?.length ?? 0;
        const i = selectedIndex ?? this.metafieldsData?.featuredFlickity?.selectedIndex ?? 0;
        if (n <= 1 || i <= 0) return null;
        return i - 1;
      }
      _nextSlide(selectedIndex, length) {
        const n = length ?? this.metafieldsData?.featuredFlickity?.cells?.length ?? 0;
        const i = selectedIndex ?? this.metafieldsData?.featuredFlickity?.selectedIndex ?? 0;
        if (n <= 1 || i >= n - 1) return null;
        return i + 1;
      }
      removeclass(flkty) {
        flkty.cells.forEach(c => {
          c.element.classList.remove('is-previous', 'is-next');
        });
      }

      /* -------- aplica clases prev/next y ata listeners UNA sola vez -------- */
      _changeMethods() {
        const flkty = this.metafieldsData.featuredFlickity;
        if (!flkty) return;

        // Aplica clases ahora
        this.removeclass(flkty);
        const prevEl = this._previusSlide(flkty.selectedIndex, flkty.cells.length);
        const nextEl = this._nextSlide(flkty.selectedIndex, flkty.cells.length);
        if (prevEl !== null) flkty.cells[prevEl].element.classList.add('is-previous');
        if (nextEl !== null) flkty.cells[nextEl].element.classList.add('is-next');

        // Listener de cambio: solo una vez
        if (!this._boundOnChange) {
          this._boundOnChange = () => {
            this.removeclass(flkty);
            const p = this._previusSlide(flkty.selectedIndex, flkty.cells.length);
            const n = this._nextSlide(flkty.selectedIndex, flkty.cells.length);
            if (p !== null) flkty.cells[p].element.classList.add('is-previous');
            if (n !== null) flkty.cells[n].element.classList.add('is-next');
          };
          flkty.on('change', this._boundOnChange);
        }

        // Click en celdas: no llames select() al montar; átalo una sola vez
        flkty.cells.forEach((cell, idx) => {
          const el = cell.element;
          if (el._selectBound) return;
          el.addEventListener('click', () => flkty.select(idx));
          el._selectBound = true;
        });
      }

      destroyFlky() {
        this.metafieldsData.featuredFlickity.destroy();
        this.metafieldsData.features.classList.remove('flickity-enabled')
        this.metafieldsData.featuredFlickity = null;
        this._boundOnChange = null; // limpia referencia
      }

      /* -------- init principal -------- */
      _metafeatures(width) {
        if (!this.metafieldsData || !this.metafieldsData.features) return;

        const featuresContainer = this.metafieldsData.features.querySelector('.product-metafield');
        const items = Array.from(featuresContainer.querySelectorAll('[data-figure-item]'));
        const containerW = featuresContainer.offsetWidth;
        const isMobile = window.innerWidth <= 768;
        // suma anchos
        let totalCardsWidth = 0;
        items.forEach(it => { totalCardsWidth += it.offsetWidth; });

        if (totalCardsWidth < containerW) {
          // no necesita carrusel; si había uno, destrúyelo
          if (this.metafieldsData.featuredFlickity) {
            this.destroyFlky()
          }
          return;
        }

        // Evita doble init si ya existe
        if (this.metafieldsData.featuredFlickity) return;

        const indexInit = this.getMiddleIndex(items.length);
        const enableInfinityLoop = items.length > 2;

        const flkty = this.metafieldsData.featuredFlickity = this.setupFlickity({
          container: featuresContainer,
          cellSelector: '[data-figure-item]',
          buttons: false,
          resize: true,
          initialIndex: indexInit,
          wrapAround: enableInfinityLoop
        });

        this.metafieldsData.features.classList.add('flickity-enabled');

        // Botones (átalos una vez por DOM)
        const nextBtn = this.metafieldsData.features.querySelector('.right-arrow');
        const prevBtn = this.metafieldsData.features.querySelector('.left-arrow');
        if (nextBtn && !nextBtn._bound) {
          nextBtn.addEventListener('click', () => flkty.next());
          nextBtn._bound = true;
        }
        if (prevBtn && !prevBtn._bound) {
          prevBtn.addEventListener('click', () => flkty.previous());
          prevBtn._bound = true;
        }

        // Callbacks: pasa funciones, no ejecuciones
        const updateFlag = () => this.updateCompactFlag(flkty, featuresContainer);
        flkty.on('ready', updateFlag);
        flkty.on('select', updateFlag);
        flkty.on('resize', updateFlag);
        setTimeout(updateFlag, 0);

        // Aplica clases prev/next y listeners (una sola vez)
        this._changeMethods();
      }


      unload() {

      //
        this.galleryComponent ?. unload();

      }

  // ========== Static helpers ==========
      static mount(root) {
        if (!root) return null;
        
        const productConfig = document.querySelector('[data-section-type="static-product"]');

        const productParsed = productConfig
          ? JSON.parse(productConfig.textContent)
          : {};
        return new ProductEnhanced(root, productParsed);
      }
}

class ProductEnhancer {
      constructor(galleryElement, config, productEnhanced) {
        this.galleryElement = galleryElement;
        this.config = config;
        this.productEnhanced = productEnhanced;

        this._twState = new WeakMap();

        this.init();
      }



      init() {
        this.setupPinProductInfo()
      }

      /* =========================
      * Typewriter helpers (acoplados a la clase)
      * ========================= */

      _commonPrefixLen(a = '', b = '') {
        const len = Math.min(a.length, b.length);
        let i = 0;
        for (; i < len; i++) if (a[i] !== b[i]) break;
        return i;
      }

      /**
       * Efecto de "typewriter" que edita el contenido de texto de un elemento.
       * @param {HTMLElement} el
       * @param {string} nextText
       * @param  opts
       */
      typewriterEdit(el, nextText, opts = {}) {
        const {
          typeSpeed = 18, // ms por caracter al escribir
          deleteSpeed = 10, // ms por caracter al borrar
          keepCaret = false,
        } = opts;

        if (!el) return;

        // Cancelación de una animación anterior para este elemento
        const prevState = this._twState.get(el);
        if (prevState?.cancel) prevState.cancel();

        // Respeta reduce motion
        if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
          el.textContent = nextText;
          el.classList?.remove('tw-caret');
          this._twState.set(el, null);
          return;
        }

        el.setAttribute('aria-live', 'polite');
        el.classList?.add('tw-caret');

        const state = { canceled: false, timers: [] };
        state.cancel = () => {
          state.canceled = true;
          state.timers.forEach((t) => clearTimeout(t));
          if (!keepCaret) el.classList?.remove('tw-caret');
        };
        this._twState.set(el, state);

        const current = el.textContent || '';
        const keepLen = this._commonPrefixLen(current, nextText);

        // Si el texto es completamente distinto, se borra y reescribe
        const toDelete = Math.max(0, current.length - keepLen);
        const toType = nextText.slice(keepLen);

        const schedule = (fn, ms) => {
          const id = setTimeout(fn, ms);
          state.timers.push(id);
        };

        // 1) Borrado
        let delIdx = 0;
        const stepDelete = () => {
          if (state.canceled) return;
          if (delIdx < toDelete) {
            el.textContent = current.slice(0, current.length - delIdx - 1);
            delIdx++;
            schedule(stepDelete, deleteSpeed);
          } else {
            stepType();
          }
        };

        // 2) Escritura
        let typeIdx = 0;
        const stepType = () => {
          if (state.canceled) return;
          if (typeIdx < toType.length) {
            el.textContent = nextText.slice(0, keepLen + typeIdx + 1);
            typeIdx++;
            schedule(stepType, typeSpeed);
          } else {
            if (!keepCaret) el.classList?.remove('tw-caret');
          }
        };

        // Start
        if (toDelete > 0) {
          schedule(stepDelete, deleteSpeed);
        } else {
          schedule(stepType, typeSpeed);
        }
      }

      setupPinProductInfo() {

        if (window.innerWidth < 769) return;

        const productInfo = this.productEnhanced.productInfo;

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null; // liberar memoria
        }

        this.resizeObserver = new ResizeObserver(entries => {
          for (const entry of entries) {
            if (this.flickityAddon) {
              this.flickityAddon.resize();

            }
            const height = entry.contentRect.height;

            this._setupMovement(height, productInfo);
          }
        });

        this.resizeObserver.observe(productInfo.children[0]);

      }

      _setupMovement(height, product) {
        // Mata instancias previas
        if (this.scrollTrigger) this.scrollTrigger.kill();

        const wrapper = product.children[0];

        const productViewerH   = product.clientHeight;
        const galleryContainerH = wrapper.clientHeight;

        const calcPrev = productViewerH - galleryContainerH;
        const calc     = Math.max(0, calcPrev);

        this.scrollTrigger = window.ScrollTrigger.create({
          trigger: wrapper,
          start: 'top top',
          end: () => `+=${calc}`,
          pin: true,                
          pinSpacing: false,         
          anticipatePin: 1,          
          invalidateOnRefresh: true
        });
      }

      
      switchVariantData(data) {

        const {currentVariant, actualMetafield, currentChip, chipChanged} = data;
        

        this.currentVariant = currentVariant;
        this.currentChip = currentChip;
        this.metafields = actualMetafield;

        // Lógica para el primer renderizado
        this.switchImages(actualMetafield);
        this.switchThumbnails(actualMetafield);
        this.switchTitle(currentVariant, currentChip);
        this.switchPrice(currentVariant);
        this.switchChip(currentChip);
        this.switchSkuandUPC(currentVariant);
        this.switchKeyFeatures(actualMetafield);
        this.switchDescription(currentVariant);
        this.switchFeatures(actualMetafield);
        this.switchSpecifications(actualMetafield);
        this.switchCustomizationData(currentVariant);
        window._theme.detectVariantChange(currentVariant)


      }

      switchCustomizationData(currentVariant) {
        if (!currentVariant) return;
        const container = this.productEnhanced.customization;
        const sku = container.querySelector('[data-sku]');
        const upc = container.querySelector('[data-upc]');
        const skuinput = container.querySelector('input[name="contact[SKU]"]');
        const upcinput = container.querySelector('input[name="contact[UPC]"]');
        const compatibilities = container.querySelector('[data-compatibilities]');
        const compatibilitiesValue = container.querySelector('[data-values]');
        const img = container.querySelector('img.customization-form__image');


        if (currentVariant && currentVariant.sku && container && sku && skuinput) {
          sku.textContent = currentVariant.sku;
          skuinput.value = currentVariant.sku;
        }

        if (currentVariant && currentVariant.barcode && container && upc && upcinput) {
          upc.textContent = currentVariant.barcode;
          upcinput.value = currentVariant.barcode;
        }

        if (currentVariant && currentVariant.options && container && compatibilities) {
          compatibilitiesValue.textContent = currentVariant.options.join(', ');
        }

        if (currentVariant && currentVariant.featured_image && container && img) {
          this.switchImageData(img, currentVariant.featured_image.src, "customization image");
        }
      }


      switchThumbnails(metafields) {
        const imagesContainer = this.galleryElement.querySelector('[data-gallery-thumbnails]');
        const meta = metafields[0].metafields.images_featured_thumb;

        const images = Array.from(imagesContainer.querySelectorAll('[data-gallery-thumbnail]'));

        images.forEach((figure, index) => {
          const metafield = meta[index];
          const img = figure.querySelector('img');
          if (metafield) {
            this.switchImageData(img, metafield.url, `"thumbnail" ${metafield.mediatype}`);
          }
        });

      }

      


      /**
       * Updates the product specifications UI with new metafield data.
       *
       * @param {Object} metafield - The metafield data for specifications.
       *   Expected structure: [{ metafields: { specifications: Array<Spec> } }]
       *   where Spec = { image: string, value: Array<{ name: string, value: string }> }
       */

      
      switchSpecifications(metafield) {
        // The container in the DOM that holds the specifications section
        const specsContainer = this.productEnhanced.metafieldsData.specifications;

        // If no container exists or no metafield data is passed, exit early
        if (!specsContainer || !metafield) return;

        // Get the specifications array from the first metafield entry
        const meta = metafield[0].metafields.specifications;

        // Iterate over each specification object
        meta.forEach((spec, index) => {
          // Select the container element that corresponds to this spec index
          const container = specsContainer.querySelector(`[data-index-container="${index}"]`);

          // Each spec may have an image → update if found
          const img = container.querySelector('img');
          if (img) {
            this.switchImageData(img, spec.image, "specification image");
          }
          const valueContainer = container.querySelector('.specs_list');

          // If this spec has a list of values (array of {name, value}), render them
          if (spec.value && spec.value.length > 0) {
            spec.value.forEach((value, valueIndex) => {
              // Container for the list of spec values


              // Select the specific list item by its index
              const valueItem = valueContainer.querySelector(`.specs_list_item[data-index="${valueIndex}"]`);

              if (!valueItem) return;

              if (valueItem.contains("hideme")) {
                valueItem.classList.remove("hideme");
              }

              // Update the spec name
              const name = valueItem.querySelector('.specs_list_item_name');
              if (name) {
                name.textContent = value.name;
              }

              // Update the spec value
              const val = valueItem.querySelector('.specs_list_item_value');
              if (val) {
                val.textContent = value.data;
              }
            });

            const valueLength = spec.value.length;

            const valueItems = Array.from(valueContainer.querySelectorAll('.specs_list_item'));

            if (valueLength > valueItems.length) {
              // If there are more values than items, hide the extra items
              valueItems.slice(valueLength).forEach(item => {
                item.classList.add('hideme');
              });
            }

          }
        });
      }

      destroyFlickity() {
        this.productEnhanced?.metafieldsData.featuredFlickity?.destroy?.();
        // this.productEnhanced?.metafieldsData.featuredFlickity = null;
        if (this.productEnhanced?.metafieldsData.features.contains('flickity-enabled')) {
          this.productEnhanced?.metafieldsData.features.remove('flickity-enabled');
        }
      }

      switchFeatures(metafields) {
        const state = this.productEnhanced?.metafieldsData;
        if (!state?.features) return;
        
        
        const actualCardsRendered = Array.from(state.features.querySelectorAll("[data-figure-item]"))
        const metafieldData = metafields[0].metafields.features;
        const container = state.features.querySelector('.product-metafield');
        const width = window.innerWidth;

        if (this.productEnhanced?.metafieldsData?.featuredFlickity) this.productEnhanced?.destroyFlky();


        if (metafieldData) {
          actualCardsRendered.forEach(item => item.remove());
          metafieldData.forEach((item, index) => {
            const figure = this.figureCreation(item);
            container.appendChild(figure);
          });
          this.productEnhanced?._metafeatures?.(width);
        }

      }

      figureCreation(item) {
          const figure = document.createElement('figure');
          figure.classList.add('product-metafield__image');
          figure.setAttribute('data-figure-item', '');

          const img = document.createElement('img');
          img.classList.add('product-gallery--loaded-image', 'lazyShow');

          const caption = document.createElement('figcaption');
          caption.classList.add('product-metafield__name');
          caption.textContent = item.name || '';

          figure.appendChild(img);
          figure.appendChild(caption);

          this.switchImageData(img, item.image, item.name);

          return figure;
      }



      switchImageData(imgElement, url, alt) {
        imgElement.src = url || '';
        imgElement.alt = alt || '';
        imgElement.setAttribute('data-srcset', `${url} 1x, ${url} 2x, ${url} 2.85x`);
        imgElement.setAttribute('srcset', `${url} 1x, ${url} 2x, ${url} 2.85x`)
        imgElement.setAttribute('data-src', url);
      }

      switchSkuandUPC(currentVariant) {
        const elements = {
          sku: currentVariant.sku,
          upc: currentVariant.barcode
        }

        const skuElement = this.productEnhanced.productInfo.querySelector('[data-product-sku]');
        const upcElement = this.productEnhanced.productInfo.querySelector('[data-product-upc]');

        if (skuElement) {
          skuElement.textContent = elements.sku;
        }

        if (upcElement) {
          this.typewriterEdit(upcElement, elements.upc, {
            typeSpeed: 18,
            deleteSpeed: 10,
            keepCaret: false,
          });
        }
      }
      

       
        /**
         * @typedef {Object} MediaItem
         * @property {string} url
         * @property {"image"|"modelviewer"|"gif"|"video"} [mediatype="image"]
         */

        /**
         * Updates up to 6 <figure> elements with new media.
         * - 1st and last are always images (zoom allowed).
         * - Indices 1..4 may be image | modelviewer | gif | video.
         *
         * @param {HTMLElement[]} images            // figure elements (length = 6)
         * @param {MediaItem[]} data                // media payload matching indices
         * @param {string[]} [description]          // captions for indices 1..4
         */
        
      changeDataOfImage(images, data, description = []) {
        const isMiddle = (i, len) => i > 0 && i < len - 1; // 2nd..(n-1)

        images.forEach((figure, index) => {
          const descriptionIndex = index - 1;
          const item = data[index] || {};
          const newSrc = item.url;
          const mediaType = (item.mediatype || 'image').toLowerCase();

          if (!newSrc) return; // nothing to do

          // Ensure we have/clean the expected DOM inside the figure
          let imgEl = figure.querySelector('img');
          let caption = figure.querySelector('figcaption');
          
          
          // Middle figures have captions; first/last do not
          if (isMiddle(index, images.length)) {
            if (!caption) {
              caption = document.createElement('figcaption');
              figure.appendChild(caption);
            }
            caption.textContent = description[descriptionIndex] || '';
          }

          // If there's no <img>, create one and reset content order: img [figcaption?]
          if (!imgEl) {
            // keep figcaption if present, but rebuild cleanly
            const capText = caption ? caption.textContent : null;
            figure.innerHTML = '';
            imgEl = document.createElement('img');
            imgEl.classList.add('product-gallery--loaded-image', 'lazyShow');
            figure.appendChild(imgEl);
            if (isMiddle(index, images.length)) {
              const newCap = document.createElement('figcaption');
              newCap.textContent = capText || description[descriptionIndex] || '';
              figure.appendChild(newCap);
              caption = newCap;
            }
          }

          // Always update the visual source via your helper
          this.switchImageData(imgEl, newSrc, description[descriptionIndex] || '');

          // Persist media type on the figure for downstream logic
          figure.dataset.mediaType = mediaType;

          // ---- Zoom rules --------------------------------------------------------
          const hadListener = figure.getAttribute('data-listener-active');

          if (mediaType === 'image') {
            // Allowed to have zoom
            imgEl.setAttribute('data-zoom', newSrc);
            figure.style.backgroundImage = `url(${newSrc})`;
            figure.dataset.zoom = newSrc;

            // (Re)attach zoom listener once if you need it
            if (!hadListener && this?.productEnhanced?.setupZoom) {
              figure.addEventListener('click', this.productEnhanced.setupZoom);
              figure.setAttribute('data-listener-active', 'true');
            }
          } else {
            // Not allowed to have zoom → strip everything zoom-related
            imgEl.removeAttribute('data-zoom');
            figure.style.backgroundImage = '';
            figure.removeAttribute('data-zoom');
            delete figure.dataset.zoom;

            if (hadListener && this?.productEnhanced?.setupZoom) {
              figure.removeEventListener('click', this.productEnhanced.setupZoom);
              figure.removeAttribute('data-listener-active');
            }
          }
          // -----------------------------------------------------------------------
        });
      }

      switchImages(metafields) {
        if (!metafields?.length || !metafields[0]?.metafields?.images_featured) return;
        
        const images = Array.from(this.galleryElement.querySelectorAll('[data-figure_img]'))
        const metafieldImages = metafields[0].metafields.images_featured;
        const metafieldThumbs = metafields[0].metafields.images_featured_thumb;
        const imagesCaption = metafields[0].metafields.images_description;
        const imagesThumb = Array.from(this.galleryElement.querySelectorAll('[data-gallery-thumbnail]'))

        this.changeDataOfImage(images, metafieldImages, imagesCaption);

        // this.loadingImages(images)


        if (this.productEnhanced.galleryZoom) {
          this.productEnhanced.galleryZoom.unload();
          this.productEnhanced.galleryZoom = null;
        }

        images.forEach((element, index) => {
          element.addEventListener('click', () => {
            this.productEnhanced.setupZoom({
              settings: this.config.settings,
              slides: images,
              startSlide: element,
              originalThumbnails: Array.from(this.galleryElement.querySelectorAll('[data-gallery-thumbnail]')),
              startIndex: index
            });
          });
        });

          
        


      }

      switchKeyFeatures(metafields) {
        const keyFeaturesContainer = this.productEnhanced.productInfo.querySelector('[data-features-kf]');
        const keyImages = metafields[0].metafields.key_features_images;
        const keyDescrip = metafields[0].metafields.key_features_descriptions;

        if (! keyFeaturesContainer) return;
        

        const items = Array.from(keyFeaturesContainer.querySelectorAll('.kf__item'));

        items.forEach((item, index) => {
          const imageElement = item.querySelector('img');
          const descriptionElement = item.querySelector('.kf__text');

          if (imageElement) {
            imageElement.src = `${keyImages[index]}`;
          }

          if (descriptionElement) {
            descriptionElement.textContent = keyDescrip[index];
          }
        })

        // Lógica para cambiar las características clave del producto
      }

      switchVariantChip(currentChip, currentVariant) {
        this.currentChip = currentChip;
        const productTitle = this.productEnhanced.productInfo.querySelector('.product_title');

        if (!productTitle) return;

        
        const currentVariantTitle = currentVariant.name.split(' - ')[0];
        const newTitle = `${currentVariantTitle}${currentChip ? ` - ${currentChip.dataset.chip}` : ''}`;

        this.typewriterEdit(productTitle, newTitle, {
          typeSpeed: 18,
            deleteSpeed: 10,
            keepCaret: false
          });

      }

      switchTitle(currentVariant, currentChip) {
        if (!currentVariant && !currentChip) return;
        


        const titleVariant = currentVariant.name.split(' - ')[0];

        const titleChip = currentChip
          ? ` - ${currentChip.dataset.chip}`
          : '';

        const newTitle = `${titleVariant}${titleChip}`;

        const productTitle = this.productEnhanced.productInfo.querySelector('.product_title');


        this.typewriterEdit(productTitle, newTitle, {
          typeSpeed: 18,
          deleteSpeed: 10,
          keepCaret: false
        });

  // Lógica para cambiar el título del producto
      }
      
      switchPrice(currentVariant) {
        const priceElement = this.productEnhanced.productInfo.querySelector('[data-price]');

        const formatMoney = window.Shopify.formatMoney || ((money, format) => {
          let calc = (money / 100).toFixed(2);
          return `$${calc}`;  
        }); // Fallback for formatMoney

        if (priceElement) {
          this.typewriterEdit(priceElement, formatMoney(currentVariant.price, this.config.settings.money_format), {
            typeSpeed: 18,
            deleteSpeed: 10,
            keepCaret: false
          });
        }
      }

      switchDescription(currentVariant) {

  // Lógica para cambiar la descripción del producto
      }
      
      switchChip(currentChip) {

  // Lógica para cambiar el chip del producto
      }
      unload() {

  // Cleanup product enhancements
      }

}

class ProductClickToZoom {
      constructor({
        settings,
        slides,
        startSlide,
        originalThumbnails,
        startIndex
      }) {
        this.settings = settings;
        this.slides = slides;
        this.indexSel = startIndex;
        this.selectedSlide = startSlide;
        this.photoswipeDialog = document.querySelector('[data-photoswipe]');
        this.thumbContainer = this.photoswipeDialog.querySelector('[data-photoswipe-thumbs]');
        this.thumbScroller = this.photoswipeDialog.querySelector('[data-photoswipe-thumb-scroller]');
        this.thumbScrollerButtons = this.photoswipeDialog.querySelectorAll('[data-gallery-scroll-button]');
        this.closeButton = this.photoswipeDialog.querySelector('.pswp__button--close');
        this.thumbScroller.innerHTML = '';
        this.thumbnails = [];
        let selectedIndex = startIndex; // Clone the original thumbnails into the photoswipe dialog

        originalThumbnails.forEach((thumb, thumbIndex) => {
          if (thumb.dataset.mediaType !== 'image') {
            if (startIndex > thumbIndex) 
              selectedIndex--;
            
            return;
          }

          const newThumb = thumb.cloneNode(true);
          this.thumbScroller.appendChild(newThumb);
          this.thumbnails.push(newThumb);
        });
        rimg_shopify_dist_index_es.watch(this.thumbContainer);
        this.selectedThumb = this.thumbContainer.querySelector(`[data-thumb-index="${startIndex}"]`);
        this.events = new window.EventHandler() // Set up options for initializing PhotoSwipe

        const photoswipeSlides = [];
        slides.forEach(slide => {
          if (['video', 'external_video', 'model'].indexOf(slide.dataset.mediaType) > -1) return;
          
          photoswipeSlides.push({src: slide.dataset.zoom, msrc: slide.dataset.zoom, h: slide.dataset.imageHeight, w: slide.dataset.imageWidth});
        }); // Adjust the bottom bar height to allow for the mobile thumbnails

        const bottomBarHeight = window.Layout.isGreaterThanBreakpoint('L', true)
          ? 0
          : 75;
        const photoswipeOptions = {
          index: selectedIndex,
          barsSize: {
            top: 0,
            bottom: bottomBarHeight
          },
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: false,
          arrowEl: false,
          preloaderEl: false,
          closeOnScroll: false,
          showHideOpacity: true,
          history: false,
          loop: true,
          clickToCloseNonZoomable: false,
          timeToIdle: false,
          timeToIdleOutside: false
        };

        if (this.settings.gallery_click_to_zoom === 'always' || window.Layout.isGreaterThanBreakpoint('S', true) && this.settings.gallery_click_to_zoom === 'desktop' || window.Layout.isLessThanBreakpoint('S') && this.settings.gallery_click_to_zoom === 'mobile') {
          photoswipeOptions.getThumbBoundsFn = () => {
            const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            const indexImg = this.slides[this.indexSel] || this.slides[0];
            const bounds = indexImg.querySelector('[data-rimg]').getBoundingClientRect();
            return {
              x: bounds.left,
              y: bounds.top + pageYScroll,
              w: bounds.width
            };
          };
        }

        this.photoswipe = new(window.photoswipe_default())(this.photoswipeDialog, (window.photoswipe_ui_default_default()), photoswipeSlides, photoswipeOptions);
        this.events.register(this.closeButton, 'click', () => this.photoswipe.close()); // The following fixes an issue on iOS12 and below, where click events were not registering

        this.events.register(this.closeButton, 'touchstart', () => this.photoswipe.close());
        this.thumbnails.forEach((thumb, index) => {
          this.events.register(thumb, 'click', () => {
            this.photoswipe.goTo(index);
          });
        });
        this.events.register(this.thumbScroller, 'scroll', () => this._handleScrollButtonVisibility());
        this.events.register(this.thumbScrollerButtons[0], 'click', () => this._onScrollButtonClick(true));
        this.events.register(this.thumbScrollerButtons[1], 'click', () => this._onScrollButtonClick(false));

  // Photoswipe documentation claims that the closeOnVerticalDrag option is always false if
  // the mouse is used, which is what we want. Unfortunately that's not how it actually works,
  // so we need to dynamically update the setting when a mouse is detected.

        if (this.photoswipe.options.mouseUsed) {
          this.photoswipe.options.closeOnVerticalDrag = false;
        } else {
          this.photoswipe.listen('mouseUsed', () => {
            this.photoswipe.options.closeOnVerticalDrag = false;
          });
        }

        this.photoswipe.listen('afterChange', () => {
          const index = this.photoswipe.getCurrentIndex();

          if (this.selectedThumb) {
            this.selectedThumb.dataset.gallerySelected = false;
          }
          this.selectedThumb = this.thumbnails[index];
          this.selectedThumb.dataset.gallerySelected = true;
          const slideIndex = this.selectedThumb.getAttribute('data-gallery-index');
          const slide = slides[slideIndex];

          this._adjustMobileThumbPosition();

          this._handleScrollButtonVisibility();

          this.selectedSlide = slide;
          this.indexSel = slideIndex;
        });
        this.photoswipe.listen('close', () => {
          window.removeTrapFocus(this.photoswipeDialog);
          this.photoswipe = null;
        });
        this.photoswipe.listen('destroy', () => {
          this.events.unregisterAll();
          this.photoswipe = null;
        }); // Detect if mouse is over the thumbnails, if it is allow scroll left/right

        this.events.register(this.thumbContainer, 'mouseenter', () => {
          if (window.Layout.isLessThanBreakpoint('S')) {
            this.photoswipe.options.closeOnScroll = true;
          }
        });
        this.events.register(this.thumbContainer, 'mouseleave', () => {
          if (window.Layout.isLessThanBreakpoint('S')) {
            this.photoswipe.options.closeOnScroll = false;
          }
        });

  // If a user closes the dialog using the escape key, then we should focus
  // on the expand button.

        const closeEsc = e => {
          if (e.key === 'Escape') {
            // slides[0].parentNode.querySelector('[data-gallery-expand]').focus();
          }
        };

        this.events.register(window, 'keydown', e => closeEsc(e));
        this.photoswipe.init();
        window.trapFocus(this.photoswipeDialog);
      }

      _adjustMobileThumbPosition() {

  // This brings the thumbnail into view if it is not visible on the screen after
  // a user swipes to a slide that it is tied to.
        if (window.Layout.isLessThanBreakpoint('S')) {
          const thumbBounds = this.selectedThumb.getBoundingClientRect();
          const thumbWrapperBounds = this.thumbScroller.getBoundingClientRect();

          if (thumbBounds.left + thumbBounds.width + 30 > thumbWrapperBounds.width) {
            this.thumbScroller.scrollLeft = this.selectedThumb.offsetLeft + thumbBounds.width - thumbWrapperBounds.width + 35;
          } else if (this.selectedThumb.offsetLeft<this.thumbScroller.scrollLeft) {
        this.thumbScroller.scrollLeft = this.selectedThumb.offsetLeft - 35;
      }
    }
  }

  _handleScrollButtonVisibility() {
    if (window.Layout.isLessThanBreakpoint('S')) {
      // We use 4px here just to ensure the user has scrolled a little bit before
      // showing the buttons.
      if (this.thumbScroller.scrollLeft> 4) {
            this.thumbScrollerButtons[0].classList.add('visible');
          } else {
            this.thumbScrollerButtons[0].classList.remove('visible');
          }

          if (this.thumbScroller.scrollLeft<this.thumbScroller.scrollWidth - this.thumbScroller.clientWidth) {
        this.thumbScrollerButtons[1].classList.add('visible');
      } else {
        this.thumbScrollerButtons[1].classList.remove('visible');
      }
    } else {
      this.thumbScrollerButtons[0].classList.remove('visible');
      this.thumbScrollerButtons[1].classList.remove('visible');
    }
  }

  _onScrollButtonClick(scrollRight) {
    if (scrollRight) {
      this.thumbScroller.scrollLeft = this.thumbScroller.scrollLeft - 100;
    } else {
      this.thumbScroller.scrollLeft = this.thumbScroller.scrollLeft + 100;
    }
  }

  unload() {
    if (this.photoswipe) {
      this.photoswipe.destroy();
      this.photoswipe = null;
    }
  }
}





  // Auto-mount en esta página de producto
document.addEventListener('DOMContentLoaded', () => {

        const options = {
          gallery: document.querySelector('[data-gallery]'),
          productInfo: document.querySelector('[data-product-info]'),
          productContainer: document.querySelector('[data-product-container]'),
          variantPicker: document.getElementById('VariantPicker'),
          product_metafields: document.querySelector('[data-metafields-wrapper]')
        }
        if (! options) return;
        
        const instance = ProductEnhanced.mount(options);

        // Exponer para debugging si quieres:
        window.ProductEnhanced = ProductEnhanced;
        window.__pe__ = instance;
});
